import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import { getOrganizationsAction } from '../../redux/actions/users';

const mapDispatchToProps = (dispatch) => ({
  fetchFunction: () => dispatch(getOrganizationsAction()),
});

export default connect(null, mapDispatchToProps)(GenericLoader);
